import script from "./OrderFormOld.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrderFormOld.vue?vue&type=script&setup=true&lang=ts"

import "./OrderFormOld.vue?vue&type=style&index=0&id=c73f2c68&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c73f2c68"]])

export default __exports__